import React, { Fragment, Component, useState, useEffect } from "react";
import * as debounce from "lodash.debounce";
import { RangeSlider } from "rsuite";
import RangeFilter from './RangeFilter';
// import "rsuite/dist/styles/rsuite-default.css";

class FacetedSearchGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anyOptionSelected:
                props.group.selectedOptions.length !== 0 ? true : false,
        };
    }

    componentDidMount() { }

    toggleFacets() {
        return this.setState((state) => {
            return {
                anyOptionSelected: !state.anyOptionSelected,
            };
        });
    }

    render() {
        const { group, searchFacetChange, sliderFilterChange } = this.props;
        return (
            <Fragment>
                <ul className="faceted-search__group">
                    <div
                        className={
                            !this.state.anyOptionSelected
                                ? "faceted-search__group-header"
                                : "faceted-search__group-header active"
                        }
                        role="faceted-search-item-group"
                        onClick={(e) => this.toggleFacets()}
                    >
                        <span>{group.label}</span>
                        {!this.state.anyOptionSelected && (
                            <i className="sicon-chevron-down"></i>
                        )}
                        {this.state.anyOptionSelected && (
                            <i className="sicon-chevron-up"></i>
                        )}
                    </div>
                    {this.state.anyOptionSelected && (
                        <li id={group.id} className="faceted-search__group-container">
                            <ul className="faceted-search__group-items">
                                {group.isSlider ?
                                    <Fragment>
                                        <div className={`input-range__container`}>
                                            <RangeFilter group={group} sliderFilterChange={sliderFilterChange} />
                                        </div>
                                    </Fragment>
                                    :
                                    group.options && group.options.map((item, itemIndex, array) => (
                                        <li key={`${item.label}-${itemIndex}`} className="faceted-search__item" role="faceted-search-item">
                                            <FacetedFilterCheckbox
                                                item={item}
                                                group={group}
                                                searchFacetChange={searchFacetChange}
                                            />
                                        </li>
                                    ))}
                            </ul>
                        </li>
                    )}
                </ul>
            </Fragment>
        );
    }
}

// FAS: Filters will be shown at the left menu even with category navigation
const FacetedSearch = ({
    facetFilters,
    query,
    searchFacetChange,
    navigationTheme,
    sliderFilterChange
}) => {

    return (
        <div className="faceted-search-parent">
            {facetFilters.length > 0 && (
                <ul className="faceted-search">
                    {facetFilters &&
                        facetFilters.map((group, groupIndex, array) => {
                            return (
                                <Fragment key={`${group.label}-${groupIndex}`}>
                                    {group.id !== "price_range" && (
                                        <FacetedSearchGroup
                                            key={`${group.label}-${groupIndex}`}
                                            group={group}
                                            searchFacetChange={searchFacetChange}
                                            sliderFilterChange={sliderFilterChange}
                                        />
                                    )}
                                </Fragment>
                            );
                        })}
                </ul>
            )}
        </div>
    );
};

const FacetedFilterCheckbox = ({ item, group, searchFacetChange }) => (
    <label className="faceted-filter">
        <input
            className="faceted-filter__input"
            type="checkbox"
            onChange={(event) => searchFacetChange(group, item)}
            checked={
                group.selectedOptions != null && group.selectedOptions.includes(item.id)
            }
        />
        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) && item.quantity != null && (
                <span className="faceted-filter__quantity">
                    &nbsp;({item.quantity})
                </span>
            )}
        </span>
    </label>
);

export default FacetedSearch;
